import { defineMessages } from 'react-intl';
export default defineMessages({
  inWishlist: {
    id: 'product.item.in.wishlist',
    defaultMessage: 'Máte v oblíbených',
  },
  addToWishlist: {
    id: 'product.item.add.to.wishlist',
    defaultMessage: 'Přidat do oblíbených',
  },
  productAddedToList: {
    id: 'wishlist.notifications.productAddedToList',
    defaultMessage: 'Přidali jste {product} do seznamu <b>{list}</b>.',
  },
  productAddedToLists: {
    id: 'wishlist.notifications.productAddedToLists',
    defaultMessage: 'Přidali jste {product} do seznamů.',
  },
  productRemovedFromList: {
    id: 'wishlist.notifications.productRemovedFromList',
    defaultMessage: 'Odstranili jste {product} ze seznamu <b>{list}</b>.',
  },
  productRemovedFromLists: {
    id: 'wishlist.notifications.productRemovedFromLists',
    defaultMessage: 'Odstranili jste {product} ze seznamů.',
  },
  productsMovedToList: {
    id: 'wishlist.notifications.productsMovedToList',
    defaultMessage: 'Vybrané produkty byly přesunuty do seznamu <b>{list}</b>.',
  },
  productsMovedToLists: {
    id: 'wishlist.notifications.productsMovedToLists',
    defaultMessage: 'Vybrané produkty byly přesunuty do seznamů.',
  },
  listsWereUpdated: {
    id: 'wishlist.notifications.listsWereUpdated',
    defaultMessage: 'Seznamy byly úspěšně aktualizovány.',
  },
  listCreated: {
    id: 'wishlist.notifications.listCreated',
    defaultMessage: 'Seznam <b>{list}</b> byl úspěšně vytvořen',
  },
  defaultListName: {
    id: 'wishlist.defaultListName',
    defaultMessage: 'Moje oblíbené',
  },
  listNameLabel: {
    id: 'wishlist.listNameLabel',
    defaultMessage: 'Název seznamu',
  },
  selectListDrawerTitle: {
    id: 'wishlist.selectListDrawer.title',
    defaultMessage: 'Vyberte seznam',
  },
  saveButton: {
    id: 'wishlist.selectListDrawer.saveButton',
    defaultMessage: 'Ulozit',
  },
  createButton: {
    id: 'wishlist.selectListDrawer.createButton',
    defaultMessage: 'Vytvořit',
  },
  newListButton: {
    id: 'wishlist.selectListDrawer.newListButton',
    defaultMessage: 'Nový seznam',
  },
  newListDrawerTitle: {
    id: 'wishlist.newListDrawerTitle',
    defaultMessage: 'Zadejte novy seznam',
  },
  createAndSaveButton: {
    id: 'wishlist.selectListDrawer.createAndSaveButton',
    defaultMessage: 'Vytvořit a uložit',
  },
  tooManyListsError: {
    id: 'wishlist.errors.tooManyLists',
    defaultMessage:
      'Dosáhli jste maximálního počtu <b>{maxLists}</b> seznamů. Pro vytvoření nového seznamu je potřeba jeden ze stávajících smazat.',
  },
  tooManyProductsInListError: {
    id: 'wishlist.errors.tooManyProductsInList',
    defaultMessage:
      'Seznam <b>{listName}</b> je plný ({maxProducts} položek). Uložte produkt do jiného seznamu, nebo odstraňte některé produkty.',
  },
});
